import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'next-i18next';
import { useSelector } from 'react-redux';
import Link from 'next/link';

import { selectBasketPaymentMethods } from '@selectors/basket';

import { getRouteUrl } from '@utils/urls';

import { DELIVERY_CONDITIONS } from '@common/routes';

import Benefits from './Benefits';
import {
  Wrapper,
  Section,
  Title,
  PaymentMethodsWrapper,
  PaymentMethodIcon,
  DeliveryTerms,
  DeliveryTermsWrapper,
} from './PaymentBenefitBlock.styled';

const PaymentBenefitBlock = ({
  spacingBottom,
  spacingTop,
  showOnlyPaymentMethods,
}) => {
  const {
    t,
    i18n: { language },
  } = useTranslation();
  const paymentMethods = useSelector(selectBasketPaymentMethods);

  return (
    <Wrapper
      data-testid="shopBenefitsBlock"
      spacingBottom={spacingBottom}
      spacingTop={spacingTop}
    >
      {!showOnlyPaymentMethods && <Benefits />}
      <Section>
        <Title>{t('shop.benefitBlock.paymentHeadline', 'Zahlungsarten')}</Title>
        <PaymentMethodsWrapper>
          {paymentMethods.map(({ code, icon }) => (
            <li key={icon}>
              <PaymentMethodIcon width={48} height={32} src={icon} alt={code} />
            </li>
          ))}
        </PaymentMethodsWrapper>
      </Section>
      {!showOnlyPaymentMethods && (
        <DeliveryTermsWrapper>
          <Link
            legacyBehavior
            href={DELIVERY_CONDITIONS}
            as={getRouteUrl(language, DELIVERY_CONDITIONS)}
            passHref
          >
            <DeliveryTerms>
              {t(
                'shop.benefitBlock.deliveryTerms.link.text',
                'Lieferbedingungen',
              )}
            </DeliveryTerms>
          </Link>
        </DeliveryTermsWrapper>
      )}
    </Wrapper>
  );
};

PaymentBenefitBlock.propTypes = {
  spacingTop: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  ),
  spacingBottom: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  ),
  showOnlyPaymentMethods: PropTypes.bool,
};

PaymentBenefitBlock.defaultProps = {
  spacingTop: null,
  spacingBottom: null,
  showOnlyPaymentMethods: false,
};

export default PaymentBenefitBlock;
